import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-slate-800 bg-slate-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-148" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-149" data-mp="2vp6cwdfhom9a">
        <div className="text-center" data-id="element-150" data-mp="39hctg0mk0v99">
          <SectionHeading id="problem-title" data-id="element-151" data-mp="39gb54ugj2c9l">Does This Sound <span className="text-amber-400" data-id="element-152" data-mp="35gkj141y4kbe">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-300" data-id="element-153" data-mp="35idinze5649w">
            You work underground as a technician, supervisor or engineer, or you want to grow in mine operations, but the
            mine still feels like separate pieces. When someone talks about stoping methods, ground support, drill
            patterns, ventilation circuits or haulage, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-slate-800 bg-slate-900 p-6 sm:p-8" data-id="element-154" data-mp="jeepsjdqdbgf">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-semibold text-white" data-id="element-155" data-mp="x6mju3dmqobf">
            <AlertTriangleIcon className="h-5 w-5 text-orange-400" aria-hidden="true" data-id="element-156" data-mp="123cw0fmbczrk" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-157" data-mp="1c1soon0zoh36">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-300" data-id="element-158" data-mp="1bzocziwumdsc">
                <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-orange-500" aria-hidden="true" data-id="element-159" data-mp="1g2kzhkpieu1k" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-160" data-mp="3hvir5d7jvgkx">
          <p className="mx-auto max-w-2xl text-lg font-semibold text-white" data-id="element-161" data-mp="p0921ualpeg4">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-bold tracking-tight text-amber-400 sm:text-3xl" data-id="element-162" data-mp="k2h7esikne88">You need one organized system.</p>
        </div>
      </div>
    </section>;
}